import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import { Quote } from 'lucide-react';

export default function Testimonial() {
  const [ref, isVisible] = useScrollAnimation(0.2);

  return (
    <section data-testid="testimonial-section" className="py-24 md:py-32 px-4 md:px-8 bg-white">
      <div className="max-w-4xl mx-auto">
        <div ref={ref} className={`scroll-fade-up ${isVisible ? 'visible' : ''} text-center`}>
          <Quote size={40} strokeWidth={1} className="text-vf-mint mx-auto mb-8" />
          <blockquote className="font-heading text-2xl sm:text-3xl lg:text-4xl text-vf-charcoal leading-relaxed tracking-tight mb-8 italic">
            "I used to spend my evenings finishing notes. Now I'm done by 5. And our billing
            denials dropped by half in the first month."
          </blockquote>
          <div>
            <p className="font-body text-base font-semibold text-vf-forest">
              Dr. Sarah M.
            </p>
            <p className="font-body text-sm text-vf-charcoal/50">
              Family Medicine &middot; Rural Wisconsin
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
